const actions = {
  setContact: ({ commit }, payload) => {
    commit('SET_CONTACT', payload);
  },
};

export { actions };
